import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=dc6167ae&scoped=true&"
import script from "./ScrollPane.vue?vue&type=script&lang=js&"
export * from "./ScrollPane.vue?vue&type=script&lang=js&"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=dc6167ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6167ae",
  null
  
)

export default component.exports